import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SessionService, User } from '@edl-development/edl-common';
import { Subscription } from 'rxjs';
import { PortalInfo } from './../../model/portal-info.model';

@Component({
    selector: 'portal-info',
    templateUrl: './portal-info.component.html'
})
export class PortalInfoComponent implements OnInit, OnDestroy {
    @Input() portalInfo: PortalInfo;
    user: User;
    form: UntypedFormGroup;
    activeUserSub: Subscription;

    constructor(
        private sessionService: SessionService
    ){}

    ngOnInit() {

        this.activeUserSub = this.sessionService.activeUser.subscribe((user: User) => {
            this.user = user;
        });


        
    }

    ngOnDestroy() {
        this.activeUserSub.unsubscribe();
    }
   
}